import { widgetState } from '../../../store/customizations/index'
import { buildElement } from '../../../utils/element'
import { PriceAdjustment } from '../../../models/price-adjustments'
import { buyOnceId, getBuyOnceAsSellingPlan, getBuyOnceAsSellingPlanGroup, isBuyOneSellingPlan, shouldShowBuyOnce } from '../../../models/buy-once'
import { getSellingPlanAllocationForVariant } from '../../../models/selling-plan-allocation'
import { getProductPrice } from '../../../store/product/getters'
import { getSellingPlanGroups } from '../../../store/selling-plans/getters'
import { getWithCurrencySymbol } from '../../../models/price-format'
import { getDiscountLabel, groupsHasAnyDiscount } from './discount'

const wrapperElementClassTiles = 'yotpo-subscription-discount-label-container'
export const buildTilesLabel = (groupId: string, planId: number, priceAdjustments: PriceAdjustment[], hasAnyDiscount: boolean): HTMLElement => {
  const containerElement = buildElement('div', 'yotpo-subscription-discount-label-container', {})

  const priceFormat = widgetState.customizations.fullFormatProductPrice
  const priceElement = buildElement('div', 'yotpo-tile-option-price', {})
  const discountPrice = getSellingPlanAllocationForVariant(groupId, planId)
  priceElement.textContent = getWithCurrencySymbol(priceFormat, discountPrice || getProductPrice())
  containerElement.appendChild(priceElement)

  if (widgetState.customizations.sellingPlans.showDiscount && hasAnyDiscount) {
    const discountElement = buildElement('div', 'yotpo-tile-option-discount', {})
    discountElement.textContent = getDiscountLabel(priceAdjustments, groupId)
    containerElement.appendChild(discountElement)
  }

  containerElement.appendChild(getStyles())

  return containerElement
}

export const replacePriceElementTiles = () => {
  const groups = getSellingPlanGroups()

  if (shouldShowBuyOnce()) {
    const buyOnce = getBuyOnceAsSellingPlanGroup()
    buyOnce.sellingPlans = [getBuyOnceAsSellingPlan()]
    groups.push(buyOnce)
  }

  const hasAnyDiscount = groupsHasAnyDiscount()
  groups.forEach(group => {
    group.sellingPlans.forEach(plan => {
      const planId = isBuyOneSellingPlan(plan.id) ? buyOnceId : plan.id
      const priceWrapElement = document.querySelector(`[data-seling-plan-group-id="${planId}"] .${wrapperElementClassTiles}`)

      if (priceWrapElement) {
        const newPriceElement = buildTilesLabel(group.id, plan.id, plan.priceAdjustments, hasAnyDiscount)
        priceWrapElement.replaceWith(newPriceElement)
      }
    })
  })
}

const getStyles = (): any => {
  const discountLabelStyle = buildElement('style', 'yotpo-discount-label-style', {})
  discountLabelStyle.innerHTML = `
    .yotpo-widget-subscriptions-add-to-cart .yotpo-subscription-discount-label-container {
      display: flex;
      margin: auto;
    }
    .yotpo-widget-subscriptions-add-to-cart .yotpo-tile-option-price, .yotpo-tile-option-discount {
      font-style: normal;
      font-family: ${widgetState.customizations.styles.fontFamily.name};
      font-size: ${widgetState.customizations.styles.fontSize.sellingPlans.options};
      font-weight: ${widgetState.customizations.styles.fontFamily.weight || 500};
      color: ${widgetState.customizations.tiles.fontColor};
      margin: 2px;
    }
    `
  return discountLabelStyle
}
